import $ from "jquery";

export default function externalLinks(translations) {
    $('a[href$=".pdf"], a[href$=".doc"], a[href$=".docx"], a[href$=".xls"], a[href$=".pptx"], a[href$=".zip"]').attr('target', '_blank');

    $('a[target="_blank"]').each(function() {
        $(this).append('<span class="sr-only">'+ translations.target_blank +'</span>')
    });
}
